export const LOGGED_IN_USER_QUERY = gql`
    query loggedInUser {
        loggedInUser {
            id
            email
            firstName
            lastName
            username
            role {
                id
                name
                hierarchyLevel
                permissions {
                    addPartner
                    viewPartner
                    editPartner
                    changePartnerStatus
                    addMerchant
                    addService
                    viewMerchant
                    editMerchant
                    cancelServices
                    changeMerchantStatus
                    unmaskPll
                    leadManagement
                    pricingAndProductManagement
                    reportingExcludingFinance
                    reportingIncludingFinance
                    stockManagement
                    viewFinance
                    viewCommissions
                    viewSelfBillingInvoices
                    addInvoice
                    addPayment
                    addCredit
                    partnerShop
                    serviceDesk
                    configurationUserManagement
                    configurationAuditLog
                    configurationFinance
                    configurationSage
                    managePartnerResources
                    configurationPartnerResources
                    configurationOther
                    customerSuccess
                    accountStatements
                }
            }
            phoneNumber
            business {
                id
                hierarchyLevel
                legalName
                partnerId
                currency
            }
            sellerId
            partner {
                id
            }
            countryCode
        }
    }
`;

export const GET_USERS = gql`
    query getUsers {
        users {
            username
            id
            lastName
            email
            firstName
            phoneNumber
            status
            business {
                hierarchyLevel
                id
                legalName
                currency
            }
            role {
                name
                id
                hierarchyLevel
            }
            countryCode
            sellerId
            pipeDriveUserId
            zenDeskUserId
        }
    }
`;

export const GET_USER = gql`
    query getUser($id: Int!) {
        user(id: $id) {
            username
            id
            lastName
            email
            firstName
            phoneNumber
            status
            business {
                hierarchyLevel
                id
                legalName
                currency
            }
            role {
                name
                id
                hierarchyLevel
            }
            countryCode
            sellerId
            partner {
                id
            }
            pipeDriveUserId
            zenDeskUserId
        }
    }
`;

export const GET_BUSINESS_USER = gql`
    query findUserByBusinessId($businessId: Int!) {
        findUserByBusinessId(businessId: $businessId) {
            username
            id
            lastName
            email
            firstName
            phoneNumber
            status
            business {
                hierarchyLevel
                id
                legalName
                currency
            }
            role {
                name
                id
                hierarchyLevel
            }
            countryCode
            sellerId
            partner {
                id
            }
            pipeDriveUserId
            zenDeskUserId
        }
    }
`;

export const DELETE_USER_MUTATION = gql`
    mutation DeleteUserMutation($id: Int!) {
        deleteUser(id: $id)
    }
`;
